(function () {
  function initialize(root) {
    if (!root || root.dataset.croGmcReady === 'true') return;
    root.dataset.croGmcReady = 'true';
    var data = root.querySelector('[data-cro-variant-data]');
    var zone = root.querySelector('[data-cro-badge-zone]');
    if (!data || !zone) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }
    var sale = zone.querySelector('[data-cro-sale-badge]');
    var fresh = zone.querySelector('[data-cro-new-badge]');
    var showNew = zone.dataset.showNew === 'true';
    function isSale(variant) {
      return Boolean(variant && variant.compare_at_price && variant.compare_at_price > variant.price);
    }
    function update() {
      var input = root.querySelector('form[id^="product-form-"] input[name="id"]');
      var variant = variants.find(function (item) { return String(item.id) === String(input && input.value); }) || variants[0];
      var onSale = isSale(variant);
      sale.classList.toggle('is-hidden', !onSale);
      fresh.classList.toggle('is-hidden', onSale || !showNew);
      zone.classList.toggle('is-empty', !onSale && !showNew);
    }
    root.addEventListener('change', function (event) {
      if (event.target.matches('input[name="id"], variant-radios input, variant-selects select')) window.setTimeout(update, 0);
    });
    update();
  }
  function start() { document.querySelectorAll('.product-cro-hero').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
